export default "__VITE_ASSET__CVvQxogP__"